var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1CE2B;}\n\t.st1{fill:#EDBD2F;}\n\t.st2{fill:#D04090;}\n\t.st3{fill:#1668A5;}\n\t.st4{fill:#BA3C87;}\n\t.st5{fill:#106AA8;}\n\t.st6{fill:#AA7E4F;}\n\t.st7{fill:#C3955B;}\n\t.st8{fill:#12AEE5;}\n\t.st9{fill:#C9C9C8;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:none;stroke:#EDBD2F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:#B2B1B4;}\n\t.st13{fill:#996E48;}\n\t.st14{fill:#F9DA62;}\n\t.st15{fill:#EDDB99;}\n\t.st16{fill:#EFD378;}\n\t.st17{fill:#126AA7;}\n\t.st18{fill:#E2D588;}\n\t.st19{fill:#FAFAFA;}\n\t.st20{clip-path:url(#SVGID_2_);}\n\t.st21{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st22{clip-path:url(#SVGID_6_);}\n\t.st23{clip-path:url(#SVGID_8_);fill:#D04090;}\n\t.st24{clip-path:url(#SVGID_10_);}\n\t.st25{clip-path:url(#SVGID_12_);fill:#00AABD;}\n\t.st26{clip-path:url(#SVGID_14_);}\n\t.st27{clip-path:url(#SVGID_16_);fill:#E1CE2B;}\n\t.st28{fill:#329866;}\n\t.st29{fill:#338958;}\n\t.st30{fill:#3AA36B;}\n\t.st31{clip-path:url(#SVGID_18_);}\n\t.st32{clip-path:url(#SVGID_20_);fill:#006597;}\n\t.st33{clip-path:url(#SVGID_22_);}\n\t.st34{clip-path:url(#SVGID_24_);fill:#D04090;}\n\t.st35{clip-path:url(#SVGID_26_);}\n\t.st36{clip-path:url(#SVGID_28_);fill:#00AABD;}\n\t.st37{clip-path:url(#SVGID_30_);}\n\t.st38{clip-path:url(#SVGID_32_);fill:#E1CE2B;}\n\t.st39{clip-path:url(#SVGID_34_);}\n\t.st40{clip-path:url(#SVGID_36_);fill:#006597;}\n\t.st41{clip-path:url(#SVGID_38_);}\n\t.st42{clip-path:url(#SVGID_40_);fill:#D04090;}\n\t.st43{clip-path:url(#SVGID_42_);}\n\t.st44{clip-path:url(#SVGID_44_);fill:#00AABD;}\n\t.st45{clip-path:url(#SVGID_46_);}\n\t.st46{clip-path:url(#SVGID_48_);fill:#E1CE2B;}\n\t.st47{clip-path:url(#SVGID_50_);}\n\t.st48{clip-path:url(#SVGID_52_);fill:#006597;}\n\t.st49{clip-path:url(#SVGID_54_);}\n\t.st50{clip-path:url(#SVGID_56_);fill:#D04090;}\n\t.st51{clip-path:url(#SVGID_58_);}\n\t.st52{clip-path:url(#SVGID_60_);fill:#00AABD;}\n\t.st53{clip-path:url(#SVGID_62_);}\n\t.st54{clip-path:url(#SVGID_64_);fill:#E1CE2B;}\n\t.st55{clip-path:url(#SVGID_66_);}\n\t.st56{clip-path:url(#SVGID_68_);fill:#006597;}\n\t.st57{clip-path:url(#SVGID_70_);}\n\t.st58{clip-path:url(#SVGID_72_);fill:#D04090;}\n\t.st59{clip-path:url(#SVGID_74_);}\n\t.st60{clip-path:url(#SVGID_76_);fill:#00AABD;}\n\t.st61{clip-path:url(#SVGID_78_);}\n\t.st62{clip-path:url(#SVGID_80_);fill:#E1CE2B;}\n\t.st63{fill:#1469A6;}\n\t.st64{fill:#E8D8AF;}\n\t.st65{fill:#F7F7F7;}\n\t.st66{fill:#FFDA2D;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M168,147.9c-0.7,1.9-2.5,3.2-4.7,3.2c-2.8,0-5.2-2.3-5.1-5.1c0.1-3.1,2.4-5.1,5.1-5.1 c2.1,0,4,1.3,4.7,3.2c0.5-0.8,1.3-1.3,2.2-1.6c-1.3-2.5-3.9-4.3-6.9-4.3c-4.3,0-7.8,3.5-7.8,7.7c0,4.3,3.5,7.8,7.8,7.8 c3,0,5.7-1.8,7-4.3C169.3,149.2,168.5,148.6,168,147.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -333.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M173.8,146c0,1.3-1.1,2.3-2.4,2.3c-1.3,0-2.3-1.1-2.3-2.4c0-1.3,1.1-2.3,2.4-2.3 C172.7,143.6,173.8,144.7,173.8,146"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -333.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M165.8,145.9c0,1.3-1.1,2.3-2.4,2.3c-1.3,0-2.3-1.1-2.3-2.4c0-1.3,1.1-2.3,2.4-2.3 C164.8,143.6,165.8,144.7,165.8,145.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -333.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M167.8,146.1c0.4,0.9,0.8,1.8,1.1,2l0,0l0,0c0.6,0.7,1.5,1.1,2.5,1.1c0.9,0,1.7-0.3,2.4-1 c0.6-0.6,1-1.5,1-2.4c0-0.9-0.3-1.7-1-2.4c-0.6-0.6-1.5-1-2.4-1c-1.4,0-2.7,0.9-3.2,2.3v0C168.2,145,168,145.5,167.8,146.1  M164.1,142.7c-0.2,0-0.4-0.1-0.6-0.1c-1.8,0-3.4,1.5-3.4,3.3c0,0.9,0.3,1.7,1,2.4c0.6,0.6,1.5,1,2.4,1c0.9,0,1.8-0.4,2.5-1.1 l0.1-0.1c0.3-0.2,0.7-1.1,1.1-2c-0.2-0.6-0.4-1.1-0.5-1.2l0-0.1C166.2,143.7,165.3,142.9,164.1,142.7 M162.7,149.9 c-1.8-0.4-3.2-2-3.2-3.9c0-2.2,1.8-4,4-4c1.7,0,3.2,1.1,3.7,2.7l0,0c0.1,0.2,0.1,0.4,0.2,0.6c0.1-0.2,0.2-0.4,0.2-0.6v0 c0.6-1.6,2.1-2.7,3.8-2.7c1.1,0,2.1,0.4,2.8,1.2c0.8,0.8,1.2,1.7,1.2,2.8s-0.4,2.1-1.2,2.8c-0.8,0.8-1.7,1.2-2.8,1.2 c-1.1,0-2.2-0.5-2.9-1.3l0,0c-0.3-0.3-0.7-1-1-1.7c-0.3,0.7-0.7,1.4-1,1.7l0,0c-0.8,0.8-1.8,1.3-3,1.3 C163.2,149.9,163,149.9,162.7,149.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -333.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M170-111c-1.4,3.6-4.9,6.1-9.1,6.2c-5.4,0-10.1-4.4-9.9-9.8c0.1-6,4.7-9.8,9.9-9.9 c4.1-0.1,7.7,2.5,9.2,6.1c1-1.5,2.5-2.6,4.3-3.1c-2.5-4.9-7.6-8.2-13.4-8.2c-8.3,0-15,6.7-15.1,15c0,8.4,6.8,15.2,15.1,15.2 c5.8,0,11-3.4,13.5-8.3C172.5-108.4,171-109.5,170-111"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: -800.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_53_",
    d: "M181.1-114.7c0,2.5-2.1,4.5-4.6,4.5c-2.5,0-4.5-2.1-4.5-4.6c0-2.5,2.1-4.5,4.6-4.5 C179.1-119.2,181.1-117.2,181.1-114.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: -800.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_57_",
    d: "M165.7-114.7c0,2.5-2.1,4.5-4.6,4.5c-2.5,0-4.5-2.1-4.5-4.6s2.1-4.5,4.6-4.5 C163.7-119.3,165.7-117.2,165.7-114.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: -800.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    d: "M169.5-114.4c0.7,1.8,1.6,3.4,2.1,4l0.1,0.1l0,0.1c1.2,1.4,3,2.2,4.8,2.2c1.7,0,3.3-0.7,4.6-1.9 c1.2-1.2,1.9-2.8,1.9-4.6c0-1.7-0.7-3.3-1.9-4.6c-1.2-1.2-2.8-1.9-4.6-1.9c-2.8,0-5.2,1.8-6.1,4.4v0 C170.4-116.5,170-115.5,169.5-114.4 M162.4-121c-0.4-0.1-0.8-0.1-1.2-0.1c-3.6,0-6.5,2.9-6.5,6.4c0,1.7,0.7,3.3,1.9,4.6 c1.2,1.2,2.8,1.9,4.6,1.9c1.8,0,3.6-0.8,4.8-2.1l0.1-0.1c0.5-0.5,1.4-2.2,2.2-4c-0.5-1.1-0.8-2.1-0.9-2.3l0-0.1 C166.5-119,164.7-120.6,162.4-121 M159.7-107.2c-3.5-0.7-6.2-3.8-6.2-7.5c0-4.2,3.5-7.7,7.7-7.7c3.2,0,6.2,2.1,7.2,5.2l0,0.1 c0.1,0.3,0.3,0.7,0.4,1.1c0.2-0.4,0.3-0.8,0.4-1.1v0c1.1-3.1,4-5.2,7.3-5.2c2.1,0,4,0.8,5.4,2.3c1.5,1.5,2.2,3.4,2.2,5.4 c0,2.1-0.8,4-2.3,5.4c-1.5,1.5-3.4,2.2-5.4,2.2c-2.2,0-4.3-0.9-5.7-2.6l0,0c-0.6-0.6-1.3-1.9-2-3.3c-0.6,1.4-1.4,2.7-2,3.3l0,0 c-1.5,1.6-3.5,2.5-5.7,2.5C160.6-107,160.2-107,159.7-107.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_63_",
    x: -800.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.9,14.5c-0.1-0.4-0.4-0.7-0.9-0.8c-0.3-0.1-0.7-0.1-1-0.2c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.3-0.2-0.6-0.4-0.9 c0-0.1,0-0.2,0-0.2c0.2-0.3,0.4-0.5,0.6-0.8c0.3-0.5,0.3-1-0.1-1.4c-0.3-0.3-0.6-0.6-1-1c-0.4-0.4-0.9-0.5-1.4-0.1 c-0.3,0.2-0.5,0.4-0.8,0.6c-0.1,0.1-0.1,0.1-0.2,0c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.1-0.1-0.1-0.2c-0.1-0.3-0.1-0.7-0.2-1 c-0.1-0.5-0.5-0.9-1-0.9c-0.5,0-1,0-1.5,0c-0.5,0-0.9,0.3-1,0.8c-0.1,0.4-0.1,0.7-0.2,1.1c0,0.1-0.1,0.2-0.2,0.2 c-0.3,0.1-0.6,0.2-0.9,0.4c-0.1,0-0.2,0-0.2,0c-0.3-0.2-0.5-0.4-0.8-0.6c-0.5-0.4-1-0.3-1.5,0.1c-0.3,0.3-0.6,0.6-0.9,0.9 c-0.4,0.4-0.5,0.9-0.1,1.5c0.2,0.3,0.4,0.5,0.6,0.8c0,0,0,0.1,0,0.2c-0.1,0.3-0.2,0.6-0.4,0.9c0,0.1-0.1,0.1-0.2,0.1 c-0.3,0.1-0.7,0.1-1,0.2c-0.6,0.1-0.9,0.5-0.9,1.1c0,0.5,0,0.9,0,1.4c0,0.6,0.3,1,0.9,1.1c0.3,0.1,0.6,0.1,1,0.2 c0.1,0,0.2,0.1,0.2,0.2c0.1,0.3,0.2,0.6,0.4,0.9c0,0.1,0,0.2,0,0.2c-0.2,0.3-0.4,0.5-0.6,0.8c-0.3,0.5-0.3,1,0.1,1.4 c0.3,0.3,0.7,0.7,1,1c0.4,0.4,0.9,0.4,1.4,0.1c0.3-0.2,0.6-0.4,0.8-0.6c0.1-0.1,0.1-0.1,0.2,0c0.3,0.1,0.6,0.2,0.9,0.4 c0.1,0,0.1,0.1,0.2,0.2c0,0.3,0.1,0.7,0.2,1c0.1,0.5,0.5,0.9,1,0.9c0.5,0,1,0,1.6,0c0.5,0,0.8-0.3,0.9-0.8c0.1-0.4,0.1-0.7,0.2-1.1 c0-0.1,0.1-0.2,0.2-0.2c0.3-0.1,0.6-0.2,0.9-0.4c0.1,0,0.2,0,0.2,0c0.3,0.2,0.5,0.4,0.8,0.6c0.5,0.3,1,0.3,1.4-0.1 c0.3-0.3,0.6-0.6,1-1c0.4-0.4,0.4-0.9,0.1-1.4c-0.2-0.3-0.4-0.5-0.6-0.8c0,0,0-0.1,0-0.2c0.1-0.3,0.3-0.6,0.4-0.9 c0-0.1,0.1-0.1,0.1-0.1c0.2,0,0.4-0.1,0.6-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3-0.1,0.5-0.4,0.5-0.7C45,15.8,45,15.2,44.9,14.5 C44.9,14.6,44.9,14.6,44.9,14.5z M36.6,18.7c-1.8,0-3.2-1.5-3.2-3.2c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2 C39.9,17.3,38.4,18.8,36.6,18.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,18.4c-2.7,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S16,18.4,13.3,18.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,19.7C8.4,19.9,5,23.4,5,27.4l0,3.4c0,0.3,0.2,0.5,0.6,0.5H21c0.3,0,0.6-0.2,0.6-0.5V27 C21.6,22.8,17.6,19.5,12.9,19.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.4,29.8c-2.7,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S26.1,29.8,23.4,29.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.9,31.1c-4.5,0.2-7.8,3.8-7.8,7.8l0,3.4c0,0.3,0.2,0.5,0.6,0.5h15.4c0.3,0,0.6-0.2,0.6-0.5v-3.9 C31.7,34.3,27.7,30.9,22.9,31.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.f49c166e631821f9ee2859f5fdb64038.svg";
export { ForwardRef as ReactComponent };